import React, { useEffect, useState } from 'react'
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { getAdjustedDate } from '../CommonFunctions';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import dayjs from 'dayjs';
import { adjustTimeByFiveHoursThirtyMinutes } from '../../../Utils/DateConverstion';
import { APIConstants } from '../../../Common/APIConstants';
import { Card } from 'antd';
 
const PlantTable = (props) => {
  const theme = props.theme;
    const correctDate = new Date(getAdjustedDate());
    const [data, setData] = useState([]); 
    const { makeRequest } = useStoreUpdaterWithAPI();
    const [loading, setLoading] = useState(true);
    const [toDate, setToDate] = useState(dayjs(correctDate).hour(6).minute(0).second(0));
    // const [fromDate, setFromDate] = useState(dayjs(correctDate)
    // .subtract(30, "days")
    // .hour(6)
    // .minute(0)
    // .second(0));
    const [fromDate, setFromDate] = useState(() =>
      dayjs().startOf("month").hour(6).minute(0).second(0)
    );

    const formatDateForURL = (dateString) => {
      const date = new Date(dateString);
      date.setMilliseconds(0); // Remove milliseconds
    
      let isoString = date.toISOString().split(".")[0]; // Remove milliseconds part
      return encodeURIComponent(isoString.replace("T", " "));
    };
        const getReposnse = async () => {
          // setLoading(true)
          const currentDate = new Date();
      
          // const { from, to } = calculateDateRangeFromDate(currentDate, 1, 1);
          // console.log(fromDate)
      
          const inputData = {
            FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
            ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
          };
          console.log("getReposnse");
          console.log(formatDateForURL(inputData.ToDate), formatDateForURL(inputData.FromDate));
          // console.log(encodeURIComponent(inputData.ToDate), encodeURIComponent(inputData.FromDate));
          console.log(inputData.ToDate, inputData.FromDate);

          const url = `${APIConstants.PLANT_SEC_CONSUMPTION}?FromDate=${formatDateForURL(inputData.FromDate)}&ToDate=${formatDateForURL(inputData.ToDate)}`
          console.log(url)
          try {
            const res = await makeRequest({
              type: APIConstants.GET,
              // url: `${APIConstants.LUCAS_SF6VCB_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
              url: url,
            });
            console.log(res)
            if(res && res.length) {
              // const transformedData = res.reduce((acc, { fromDate, groupName, groupPlusMeterConsumption }) => {
              //   const formattedGroupName = groupName === "MAIN EB INCOMER" ? "eb" : groupName === "TotalConsumption" ? "Total" : groupName;
              
              //   // Remove "T" and time from fromDate
              //   const formattedDate = fromDate.split("T")[0];
              
              //   // Find an existing entry for the same fromDate
              //   let entry = acc.find(item => item.fromDate === formattedDate);
              //   if (!entry) {
              //     entry = { fromDate: formattedDate };
              //     acc.push(entry);
              //   }
              
              //   // Assign groupPlusMeterConsumption under the formatted group name
              //   entry[formattedGroupName] = groupPlusMeterConsumption;
                
              //   return acc;
              // }, []);
               
              const transformedData = res.reduce((acc, { fromDate, toDate, groupName, groupConsumptionValue }) => {
                // Format group name
                const formattedGroupName = groupName === "MAIN EB INCOMER" ? "eb" 
: groupName === "TotalConsumption" ? "Total" : groupName;
              
                // Extract only the date part from fromDate and toDate (remove time)
                const formattedFromDate = fromDate.split("T")[0];
                const formattedToDate = toDate.split("T")[0];
              
                // Check if an entry with the same fromDate-toDate period exists
                let entry = acc.find(item => item.fromDate === formattedFromDate && item.toDate === formattedToDate);
                
                if (!entry) {
                  entry = { fromDate: formattedFromDate, toDate: formattedToDate };
                  acc.push(entry);
                } 
              
                // Assign groupConsumptionValue under the formatted group name
                entry[formattedGroupName] = groupConsumptionValue;
              
                return acc;
              }, []);
              
              
              console.log(transformedData);
              const reverse = transformedData.reverse()
              console.log(reverse)
              // console.log(transformedData.reverse());
              setRowData(reverse);

            }else{ 
              setRowData([]);
            }
          } catch (error) {
            console.log(error); 
          } finally {
            setLoading(false); // Stop loading
          }
        };
      
        console.log(data);
      
        useEffect(() => {
          getReposnse();
        }, []);;

    const [rowData,setRowData] = useState();

    
      console.log(rowData)  
      const columnDefs = [
        { headerName: "Date", field: "fromDate", sortable: true, filter: true, minWidth: 140 },
        { headerName: "EB Units", field: "eb", sortable: true, filter: true, minWidth: 120 },
        { headerName: "DG Units", field: "DG", sortable: true, filter: true, minWidth: 120 },
        { headerName: "Total Units", field: "Total", sortable: true, filter: true, minWidth: 140 },
        { headerName: "SEC", field: "SEC", sortable: true, filter: true, minWidth: 100 },
        { headerName: "Production", field: "Production", sortable: true, filter: true, minWidth: 160 },
        { headerName: "AirConsumption", field: "AirConsumption", sortable: true, filter: true, minWidth: 160 },
      ];
      console.log(rowData)
  return (
<Card className={` ${theme === "dark" ? "bg-transparent" : "bg-white"
            } ag-theme-alpine w-full h-96 overflow-hidden  shadow-xl  rounded-lg`}>
  <h2 className={`${
        theme === "dark" ? "text-white" : "text-black"
      }  text-lg font-semibold text-left pl-1 `}>
    Plant SEC Data
  </h2>
{/* <div className=" h-72 rounded-lg p-0 ">
    <AgGridReact rowData={rowData} columnDefs={columnDefs} pagination={true} paginationPageSize={10} />
  </div> */}
            <div className={`${theme==='dark' ? "ag-theme-quartz-dark" : "ag-theme-alpine custom-grid-light"} h-72`} >
                  <AgGridReact 
                    rowData={rowData}
                    columnDefs={columnDefs?.length > 1 ? columnDefs : []}
                    pagination={true}
                    domLayout="normal"
                    defaultColDef={{
                      resizable: true, // Allow column resizing
                      flex: 1, // Distribute columns evenly
                      // minWidth: 160, // Ensure minimum column width
                    }}
                    rowHeight={50}
                    suppressHorizontalScroll={false}
                    overlayNoRowsTemplate={`<span style="color: gray; font-size: 16px;">No rows to show</span>`} 
                  />
                </div>

</Card>
  )
}

export default PlantTable